import { render, staticRenderFns } from "./TableListColumnEditButton.vue?vue&type=template&id=025e7fd0&"
import script from "./TableListColumnEditButton.vue?vue&type=script&lang=js&"
export * from "./TableListColumnEditButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports